import React, { FunctionComponent, useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { get, sortBy } from 'lodash';
import { ISelectMeetingInputFormProps } from '../types';
import Select from 'react-select';
import { useSelect } from '../../../../../utils/selector.utils';
import { meetingSimpleSelectors } from '../../../../../app/resource/meeting-simple/meeting-simple.selectors';
import { buildStyleForSelectInput } from '../../../../../utils/form/style.util';

export const SelectMeetingInput: FunctionComponent<ISelectMeetingInputFormProps> = ({
  id = 'meeting',
  name = 'meeting',
  defaultMeetingId,
  validation,
  disabled,
  placeholder,
  rightIcon,
  leftIcon,
  label = 'Meeting',
  isSingle,
  className,
  clearAllActionAvailable = true,
  onInputChange,
  onGetOptionLabel,
}) => {
  const { control, errors, setError } = useFormContext();

  useEffect(() => {
    if (validation && !errors[name] && control.getValues()[name] && control.getValues()[name].length < 1) {
      if (name === 'status') {
        setError(name, { type: 'minLength', message: 'You need to select a status to save' });
      } else {
        setError(name, { type: 'minLength', message: 'You need to add at least one entity' });
      }
    }
  }, [control, errors, name, setError, validation]);

  const handleChange = (e: any, controllerProps: any) => {
    if (onInputChange) {
      onInputChange(controllerProps.name);
    }
    controllerProps.onChange(e);
  };

  const CustomClearIndicator = () => {
    return null;
  };

  const meetings = useSelect(meetingSimpleSelectors.selectMeetingsLoggedUserIsPartOf);

  const meetingOptions = sortBy(
    meetings.map((meeting) => ({ value: meeting.id, label: meeting.title })),
    ['label'],
  );

  const defaultOptions = meetingOptions.find((meeting) => meeting.value === defaultMeetingId);

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultOptions || ''}
      rules={validation}
      disabled={disabled}
      render={(controllerProps) => (
        <>
          {!!get(errors, name, false) && (
            <label htmlFor={name} style={{ color: 'red' }}>
              {`${label ? label + ' - ' : ''} ${get(errors, `${name}.message`)}`}
            </label>
          )}
          {!get(errors, name, false) && <label htmlFor={name}>{label}</label>}
          {leftIcon}
          {rightIcon}
          <Select
            defaultValue={defaultOptions || ''}
            id={id}
            className={`custom-select-new ${className}`}
            name={controllerProps.name}
            disabled={disabled}
            onChange={(e) => handleChange(e, controllerProps)}
            options={meetingOptions}
            value={controllerProps.value}
            placeholder={placeholder}
            isMulti={isSingle ? undefined : true}
            closeMenuOnSelect={isSingle}
            styles={buildStyleForSelectInput(controllerProps.value?.length ?? 0)}
            getOptionLabel={onGetOptionLabel}
            components={clearAllActionAvailable ? undefined : { ClearIndicator: CustomClearIndicator }}
          />
        </>
      )}
    />
  );
};
